import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { useCallback } from 'react';
import constVars from '~/constants/constVars';
import { usePostHog } from 'posthog-js/react';
import * as Sentry from '@sentry/react';
import { getMarketBasedOnHostname } from '~/helpers/utils';

const useLogout = () => {
  const { logout } = useAuth0();
  const posthog = usePostHog();
  const { language: selectedLanguage, market } = useSelector(
    (state: RootState) => state.intl
  );

  return useCallback(
    (returnTo = constVars.ROUTE_LOAN_APPLICATION) => {
      localStorage.setItem('qredMarket', market);
      localStorage.setItem('qredLoginLanguage', selectedLanguage);
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('qredLanguage');
      posthog.reset();
      posthog.setPersonProperties({
        language: selectedLanguage,
      });
      Sentry.setUser(null);

      // DEPRECATED, see https://qredab.atlassian.net/browse/OB-3841: use the market group instead of person properties
      posthog.setPersonProperties({
        market: getMarketBasedOnHostname() ?? 'unknown',
      });

      logout({
        logoutParams: {
          returnTo: returnTo.includes('https://')
            ? returnTo
            : `${window.location.origin}/${returnTo}`,
        },
      });
    },
    [selectedLanguage]
  );
};

export default useLogout;
